<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- زر الطباعة -->
    <div class="d-flex justify-content-between align-items-center mb-4 no-print">
      <h5 class="d-none d-md-block fw-bold text-muted">تعليمات رئيس اللجنة</h5>
      <button @click="printPage" class="btn btn-dark px-4 w-100 w-md-auto">
        <i class="fas fa-print ms-2"></i> طباعة التعليمات
      </button>
    </div>

    <!-- منطقة الورقة -->
    <div class="paper-document p-4 p-md-5" id="printMe">
      
      <!-- 1. الترويسة -->
      <div class="header-section mb-4 border-bottom pb-3">
        <div class="row align-items-center gy-3 text-center">
          
          <!-- اليمين (المحافظة) -->
          <div class="col-12 col-md-4 text-md-end order-2 order-md-1">
            <h6 class="fw-bold mb-1">محافظة: شمال سيناء</h6>
            <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
          </div>
          
          <!-- الوسط (الشعار) -->
          <div class="col-12 col-md-4 order-1 order-md-2">
            <img src="https://cdn-icons-png.flaticon.com/512/3135/3135768.png" alt="logo" width="60" class="mb-2 opacity-50" />
            <h4 class="fw-bold text-decoration-underline fs-5 fs-md-4">لجنة النظام والمراقبة</h4>
          </div>

          <!-- اليسار (العام الدراسي) -->
          <div class="col-12 col-md-4 text-md-start order-3 order-md-3">
            <h6 class="fw-bold mb-1">العام الدراسي: 2025 / 2026</h6>
            <h6 class="fw-bold mb-1">الفصل الدراسي: ........................</h6>
            <h6 class="fw-bold mb-0">الدور: ........................</h6>
          </div>
        </div>
      </div>

      <!-- 2. العنوان الرئيسي -->
      <div class="text-center mb-4">
        <h2 class="section-title fs-4 fs-md-3">تعليمات وتوجيهات السيد رئيس اللجنة</h2>
        <p class="text-muted mt-2 small">يرجى الالتزام التام بما ورد أدناه لضمان حسن سير العملية الامتحانية</p>
      </div>

      <!-- 3. قائمة التعليمات -->
      <div class="instructions-content">
        <ol class="list-group list-group-numbered list-group-flush">
          
          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">الحضور والانصراف</div>
              التواجد بمقر اللجنة قبل موعد بدء العمل بوقت كافٍ، وعدم الانصراف إلا بعد التأكد من انتهاء جميع الأعمال وتأمين الكنترول.
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">استلام وتسليم الأسئلة</div>
              استلام مظاريف الأسئلة من مركز التوزيع شخصياً أو عبر المندوب المفوض، والتأكد من سلامة الأختام.
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">تأمين الغرفة السرية</div>
              التأكد من إغلاق وتشميع الغرفة السرية (الكنترول) يومياً، والاحتفاظ بالمفاتيح بصفة شخصية.
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">حظر الهاتف المحمول</div>
              التنبيه المشدد بحظر حمل أو استخدام الهاتف المحمول نهائياً داخل اللجان سواء للأعضاء أو الطلاب.
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">توزيع المهام</div>
              توزيع العمل على الأعضاء وتحديد مسئولية كل عضو بدقة في دفتر "توزيع الأعمال".
            </div>
          </li>

          <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">المحاضر والمخالفات</div>
              البت الفوري في المشكلات الطارئة، وتحرير المحاضر اللازمة لحالات الغش أو الشغب.
            </div>
          </li>
          
           <li class="list-group-item d-flex justify-content-between align-items-start px-0 px-md-3">
            <div class="ms-2 me-auto">
              <div class="fw-bold text-primary">توفير المناخ المناسب</div>
              العمل على توفير الهدوء والمناخ المناسب للأعضاء لإنجاز أعمالهم بدقة.
            </div>
          </li>

        </ol>
      </div>

      <!-- 4. الإقرار والتوقيع -->
      <div class="signature-box mt-5 p-4 border rounded-3 bg-light text-center">
        <p class="fw-bold mb-4 small">
          أقر أنا الموقع أدناه باطلاعي على التعليمات المذكورة بعالية والتزامي بتنفيذها بكل دقة.
        </p>
        <div class="row gy-4 justify-content-center">
          <div class="col-12 col-md-6">
            <h6 class="fw-bold mb-4">رئيس اللجنة</h6>
            <p>.......................................</p>
          </div>
        </div>
      </div>

      <!-- تذييل الصفحة -->
      <div class="text-center mt-5 text-muted small print-footer">
        <hr>
        نظام إدارة شئون الطلبة والامتحانات - نسخة إلكترونية
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ChairmanInstructions",
  methods: {
    printPage() {
      window.print();
    }
  }
};
</script>

<style scoped>
/* --- 1. تنسيقات الأساس (Desktop/Tablet) --- */
.paper-document {
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 0 15px rgba(0,0,0,0.05);
  /* الأبعاد القياسية لـ A4 تظهر فقط على الشاشات الكبيرة */
  min-height: 297mm; 
  width: 210mm;
  margin: 0 auto;
}

/* --- 2. تنسيقات الموبايل (Responsive) --- */
@media (max-width: 768px) {
  .paper-document {
    width: 100%; /* عرض كامل */
    min-height: auto; /* ارتفاع مرن */
    border: none;
    box-shadow: none;
    padding: 1rem !important; /* تقليل الحواف الداخلية */
  }
  
  .section-title {
    font-size: 1.2rem;
  }
  
  .list-group-item {
    padding-left: 0;
    padding-right: 0;
  }
}

/* تنسيق العنوان */
.section-title {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 800;
  border-bottom: 3px double #333;
  display: inline-block;
  padding-bottom: 10px;
}

/* تنسيق القائمة */
.list-group-item {
  border: none;
  border-bottom: 1px dashed #eee;
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: transparent;
}

.list-group-numbered > .list-group-item::before {
  font-weight: bold;
  font-size: 1.1rem;
  color: #0d6efd;
}

/* --- 3. تنسيقات الطباعة (Strict Layout) --- */
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  
  body {
    background-color: white;
  }

  .no-print {
    display: none !important;
  }

  /* إعادة ضبط الحاوية لتملأ الورقة */
  .container {
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
  }

  .paper-document {
    border: none;
    box-shadow: none;
    margin: 0;
    width: 100%;
    max-width: 100%;
    padding: 0 !important;
  }
  
  /* إجبار الأعمدة على الظهور بجانب بعضها في الطباعة (3 أعمدة) */
  .col-md-4 {
    width: 33.3333% !important;
    float: right !important; /* لمحاذاة RTL */
    flex: 0 0 33.3333% !important;
  }
  
  .text-md-end { text-align: right !important; }
  .text-md-start { text-align: left !important; }
  .order-md-1 { order: 1 !important; }
  .order-md-2 { order: 2 !important; }
  .order-md-3 { order: 3 !important; }

  /* تكبير الخطوط للطباعة */
  .list-group-item {
    font-size: 14pt;
    color: #000;
    page-break-inside: avoid; /* منع قص البند بين صفحتين */
  }

  .fw-bold {
    font-weight: 900 !important;
  }

  .bg-light {
    background-color: #f8f9fa !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>